export default "__VITE_ASSET__8864d9f2__"